import { render, staticRenderFns } from "./upgradeAi.vue?vue&type=template&id=87fb09a2&scoped=true"
import script from "./upgradeAi.vue?vue&type=script&lang=js"
export * from "./upgradeAi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87fb09a2",
  null
  
)

export default component.exports